import { SalesforceProduct } from '~/lib/salesforce/types';
import { useTranslation } from '~/shared/utils/translation';
import styles from './DeliveryDaysText.module.scss';

type DeliveryProduct = Pick<
    SalesforceProduct,
    'id' | 'c_deliveryDays' | 'c_deliveryDaysText' | 'c_deliveryDaysRange'
>;

type Props = {
    product: DeliveryProduct;
    highlighted?: boolean;
};

// SFCC delivery codes. 3 = 1 to 2 days and 10 = gift card by mail count as normal delivery.
const NORMAL_DELIVERY_CODES = ['3', '10'];
const ONE_TO_FOUR_DAYS_CODE = '7';
export const SEVEN_TO_ELEVEN_DAYS_CODES = ['63', '15'];
export const FOUR_TO_SEVEN_DAYS_CODES = ['64', '5', ...SEVEN_TO_ELEVEN_DAYS_CODES];

export const isExtendedDelivery = ({ c_deliveryDays }: DeliveryProduct) =>
    !!c_deliveryDays && !NORMAL_DELIVERY_CODES.includes(c_deliveryDays);

export const DeliveryDaysText = ({ product, highlighted = false }: Props) => {
    const { translate } = useTranslation();
    const { c_deliveryDays, c_deliveryDaysText, c_deliveryDaysRange } = product;

    if (!c_deliveryDaysText) return null;

    if (!isExtendedDelivery(product)) return <>{c_deliveryDaysText}</>;

    const key =
        c_deliveryDays === ONE_TO_FOUR_DAYS_CODE
            ? 'common.deliveryDays1To4'
            : 'common.deliveryDaysLonger';

    const text =
        (c_deliveryDaysRange && translate(key, { days: c_deliveryDaysRange })) ||
        c_deliveryDaysText;

    return highlighted ? <span className={styles.extended}>{text}</span> : <>{text}</>;
};
